import React from 'react'
import styles from './NewsElement.module.scss'
import { API_URL } from '../../../../../../http'

const NewsElement = ({ title, descr, data, image_id }) => {

  return (
    <div className={styles.news}>
      <div className={styles.news__image}>
      <img src={`${API_URL}/v1/local-files/${image_id}`} alt={image_id} />

      </div>
      <div className={styles.news__title}>{title}</div>
      <div className={styles.news__descr}>{descr}</div>
      <div className={styles.news__data}>{data}</div>
    </div>
  )
}

export default NewsElement
